export default __webpack_public_path__ + "static/soc-2-implementation-saas-companies-c4b58c2b673e15f62578a8085768b587.jpg";